<script setup lang="ts">
import { TimesIcon } from "@voltalis/ui-kit/icons";

import { useTypedIntl } from "@/locales/typed-intl";

import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

const props = defineProps<{
  selectedSectionsNb: number;
}>();

const emits = defineEmits<{
  (e: "close"): void;
  (e: "apply-program"): void;
}>();

const visible = defineModel<boolean>("visible", { required: true });

const { t, k } = useTypedIntl();
</script>

<template>
  <div
    v-if="visible"
    class="h-[108px] bg-brand p-4 flex items-center w-full justify-between"
  >
    <div class="flex items-center gap-4 text-white">
      <HospitalityButton
        class="flex h-full items-center"
        :icon="TimesIcon"
        size="xs"
        @click="emits('close')"
      />
      <span>{{ t(k.control.piloting.planning.form.countSelectedSections({ count: props.selectedSectionsNb })) }}</span>
    </div>

    <HospitalityButton
      severity="secondary"
      @click="emits('apply-program')"
    >
      <i class="pi pi-calendar mr-2" />
      {{ t(k.control.piloting.planning.form.title.create) }}
    </HospitalityButton>
  </div>
</template>
